<app-navbar></app-navbar>
<div class="bg-white dark:bg-black px-4 py-12 sm:px-6 lg:px-10">
    <div class="mx-auto w-full max-w-md">
        <div class="space-y-2 text-center mb-6">
            @if (subdomain) {
                <p class="text-xs font-semibold uppercase tracking-widest text-blue-600">
                    {{ "demoGate.exclusive" | translate }}
                </p>
                <h1 class="text-3xl font-semibold text-slate-900 dark:text-white capitalize sm:text-[2.25rem] sm:leading-tight">
                    {{ subdomain }}
                </h1>
            }
            <p class="text-base text-slate-600 dark:text-gray-400 sm:text-lg">{{ "demoGate.subtitle" | translate }}</p>
        </div>
        <div class="space-y-6">
            <form class="space-y-6" novalidate aria-live="polite" [formGroup]="form" (ngSubmit)="submit()">
                <div class="space-y-2">
                    <label for="demo-password">{{ "demoGate.passwordLabel" | translate }}</label>
                    <input pInputText id="demo-password" type="password" formControlName="password"
                        class="flex h-10 w-full rounded-md border border-gray-300 px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:cursor-not-allowed disabled:opacity-50"
                        [class.border-red-500]="passwordInvalid || showError()"
                        [class.dark:border-red-400]="passwordInvalid || showError()"
                        [attr.aria-invalid]="passwordInvalid || showError()"
                        [attr.aria-describedby]="(passwordInvalid || showError()) ? 'demo-password-error' : ''"
                        autocomplete="current-password" />
                    @if (showError()) {
                        <p id="demo-password-error" class="text-xs text-red-600 dark:text-red-400" role="alert">
                            {{ "demoGate.wrongPassword" | translate }}
                        </p>
                    } @else if (passwordInvalid) {
                        <p id="demo-password-error" class="text-xs text-red-600 dark:text-red-400" role="alert">
                            {{ "demoGate.passwordRequired" | translate }}
                        </p>
                    }
                </div>

                <p-button type="submit" styleClass="w-full dark:bg-blue-400 dark:hover:bg-blue-300"
                    [loading]="loading()" [attr.aria-busy]="loading()" aria-live="polite">
                    {{ "demoGate.enter" | translate }}
                </p-button>
            </form>

            <p class="text-xs text-slate-500 dark:text-gray-400 text-center">{{ "demoGate.footer" | translate }}</p>
        </div>
    </div>
</div>
